import fscreen from 'fscreen';
export function determineFullscreenCapability(element: HTMLElement) {
  return typeof fscreen.requestFullscreenFunction(element) === 'function';
}
